<template>
    <div class="view" ref="chart">

    </div>
</template>

<script>
  export default {
    name: "pie",
    data() {
      return {
        chartInstance: '',
        option:{}
      }
    },
    props: [
      'peopleData'
    ],
    watch: {
      peopleData: {
        handler: function (newV) {
          console.log(newV)
          this.option.series[0].data = newV
          this.option.legend.formatter = (name) => {
            let [$value] = newV.filter(item => (item.name === name))
            return [
              "{icon1| }" +
              "{value1|" + ($value.value/10000).toFixed(2) + "}" +
              "{value2|万}" + "{value3| }" +
              "{value2|" + name + "}"
            ]
          }
          console.log(this.option)
          this.chartInstance.setOption(this.option)

        },
        deep: true
      }
    },
    created() {
      this.option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: '30',
          y: 'center',
          itemWidth: 0,
          itemHeight: 38,
          itemGap: 48,
          textStyle: {
            height: 38,
            lineHeight: 40,
            rich: {
              icon1: {
                width: 6,
                height: 38,
                backgroundColor: "linear-gradient()",
                borderRadius: 100,
              },
              value1: {
                width: 140,
                fontSize: 40,
                fontWeight: 'bold',
                fontFamily: 'Bahnschrift',
                padding: [0, 4, 0, 12],
                color: '#666666'
              },
              value2: {
                fontSize: 14,
                padding: [0, 0, 8, 0],
                verticalAlign: 'bottom',
                color: '#999999'
              },
              value3: {
                width: 20
              }
            }
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['80', '135'],
            avoidLabelOverlap: false,
            itemStyle: {
              color: function ({dataIndex}) {
                const $color = [
                  {
                    start: 'rgba(252, 114, 120, 1)',
                    end: 'rgba(228, 33, 42, 1)'
                  },
                  {
                    start: 'rgba(242, 167, 106, 1)',
                    end: 'rgba(243, 149, 72, 1)'
                  },
                  {
                    start: 'rgba(112, 160, 235, 1)',
                    end: 'rgba(0, 91, 231, 1)'
                  },

                ]
                return {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: $color[dataIndex]['start'] // 0% 处的颜色
                  }, {
                    offset: 1, color: $color[dataIndex]['end'] // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            },
            center: ['184', '50%'],
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      }
    },
    mounted() {
      this.chartInstance = this.$chart.init(this.$refs['chart'])
    }
  }
</script>

<style scoped lang="scss">
    .view {
        width: 100%;
        height: 300px;
    }
</style>
